import(/* webpackMode: "eager", webpackExports: ["TopFactionTable"] */ "/app/apps/web/src/components/leaderboard/top-faction-table.tsx");
